import { isFeatureEnabled } from 'owa-feature-flags';

const editorAlEnableFeature = 'mc-officeEditorALEnabled';
const editorTonalRewriteFeature = 'mc-officeEditorTonalEnabled';
const alTuringEmailFlight = 'turingEmailFlight';

export function getFlightsToTrack(): string[] {
    const shouldEnableAl: boolean = isFeatureEnabled(editorAlEnableFeature);
    const isEditorTonalRewriteFeatureEnabled: boolean = isFeatureEnabled(editorTonalRewriteFeature);
    const isAlTuringEmailFlight: boolean = isFeatureEnabled(alTuringEmailFlight);
    let flightsToTrack: string[] = [];

    if (isEditorTonalRewriteFeatureEnabled) {
        flightsToTrack.push(editorTonalRewriteFeature);
    }

    if (shouldEnableAl) {
        flightsToTrack.push(editorAlEnableFeature);
    }

    if (isAlTuringEmailFlight) {
        flightsToTrack.push(alTuringEmailFlight);
    }

    return flightsToTrack;
}
